module.exports = __webpack_public_path__ + "media/images/front/about/point3_img03-2d4fd1585d1aaa8bc1dbe1307bc97948.jpg";